<template>
  <div>
    <b-alert show variant="primary p-3">
      <span class="text-xs">
        * Para modificar los atributos de los documentos a subir,
        es necesario seleccionarlos previamente.
      </span>
    </b-alert>
    <!-- UPLOAD FILES WIDGET -->
    <div class="w-100">
      <div class="text-right mt-3">
        <DocManagmentUploadFile
          permission="*"
          text="Seleccionar"
          v-model="fileToUpload"
          :upload-to="'default'"
          container-class="w-100"
          type-button="small"
          button-class="primary"
          @input="addFile"
          data-cy="attach-file"
        />
      </div>
    </div>
    <!-- FORM -->
    <div class="w-100">
      <form data-vv-scope="file-form" @submit.prevent="save" autocomplete="off">
        <b-alert v-model="showErrorMessage" class=" mt-2 mb-3 p-3" variant="danger" dismissible>
          <span class="text-xs">
            Existen errores que debes corregir antes de continuar!
          </span>
        </b-alert>
        <ul
          class="nav nav-tabs"
          v-if="Object.keys(filesStack).length"
        >
          <li
            v-for="(file,key,i) in filesStack"
            :key="`tab_${i}`"
            icon="description"
            class="nav-item pr-1 cursor-pointer text-gray
            border-top-0 border-left-0 border-right-0"
            :class="{
              'tab-selected': i === selectedTab
            }"
          >
            <div class="d-flex items-baseline">
              <span
                v-if="filesErrors[i] > 0"
                class="badge badge-danger"
              >
                {{ filesErrors[i] }}
              </span>
              <vs-icon @click="selectFile(i)" icon="description" size="small" color="primary" />
              <span @click="selectFile(i)">{{ `Documento #${i+1}` }}</span>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                size="small"
                @click="removeFile(key)"
              />
            </div>
          </li>
        </ul>
        <div
          class="tab-content"
          v-for="(file,key,i) in filesStack"
          :key="'tab_content_'+i"
        >
          <keep-alive>
            <div v-show="i === selectedTab">
              <!-- ORIGINAL FILE NAME -->
              <b-form-group
                label="Nombre original del documento"
                :label-for="`file_${i}_original_name`"
              >
                <b-form-input
                  :name="`file_${i}_original_name`"
                  class="w-100"
                  v-model="file.originalFileName"
                  disabled
                />
              </b-form-group>
              <!-- NAME -->
              <b-form-group
                label="Nombre para documento"
                :label-for="`file_${i}_name`"
              >
                <b-form-input
                  :id="`file_${i}_name`"
                  :name="`file_${i}_name`"
                  autocomplete="off"
                  class="w-100"
                  data-vv-as="Nombre para documento"
                  v-model="file.name"
                  v-validate="'required|max:255'"
                  :state="!errors.has(`file-form.file_${i}_name`) && file.name.length > 0"
                  data-cy="document-name"
                />
                <FormError
                  :attributeName="`file-form.file_${i}_name`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- IS PUBLIC? -->
              <b-form-group
                label="¿Es un documento de acceso público?"
                :label-for="`file_${i}_is_public`"
              >
                <vs-switch
                  :id="`file_${i}_is_public`"
                  :name="`file_${i}_is_public`"
                  color="primary"
                  vs-icon-on="done"
                  vs-icon-off="block"
                  v-model="file.isPublic"
                  class="w-16"
                  data-cy="public-document"
                >
                  <span class="pl-1" slot="on">SI</span>
                  <span slot="off">NO</span>
                </vs-switch>
                <small class="mb-2 text-danger" v-if="file.isPublic">
                  Esto dejará el archivo disponible a personas fuera de la organización
                </small>
              </b-form-group>
              <!-- PUBLICATION STATE, IS PUBLISHED -->
              <b-form-group
                label="Estado de publicación:"
                :label-for="`file_${i}_is_published`"
              >
                <b-form-select
                  class="w-100"
                  label=""
                  :id="`file_${i}_is_published`"
                  :name="`file_${i}_is_published`"
                  v-model="file.publicationState"
                  :options="publicationStateOptions"
                  data-cy="publication-status"
                />
              </b-form-group>
              <!-- EXTERNAL VERSION -->
              <b-form-group
                label="Versión externa:"
                :label-for="`file_${i}_externalVersion`"
              >
                <b-form-input
                  :id="`file_${i}_externalVersion`"
                  :name="`file_${i}_externalVersion`"
                  autocomplete="off"
                  class="w-100"
                  maxlength="10"
                  data-vv-as="Versión externa"
                  v-model.trim="file.externalVersion"
                  data-cy="external-version"

                />
                <FormError
                  :attributeName="`file-form.file_${i}_externalVersion`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- EXPIRATION TYPE -->
              <b-form-group
                label="Tipo de expiración"
                :label-for="`file_${i}_expirationType`"
              >
                <b-form-select
                  class="w-100"
                  label=""
                  :id="`file_${i}_expirationType`"
                  :name="`file_${i}_expirationType`"
                  v-model="file.selectedExpirationType"
                  v-validate="'required'"
                  data-vv-as="Tipo de expiración"
                  :options="expirationTypeOptions"
                  data-cy="expiration-type"
                />
                <FormError
                  :attributeName="`file-form.file_${i}_expirationType`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- EXPIRATION IN (X) DAYS -->
              <b-form-group
                v-if="file.selectedExpirationType === expirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS"
                label="Días"
                :label-for="`file_${i}_xDays`"
              >
                <b-form-input
                  class=""
                  data-vv-as="Días"
                  :id="`file_${i}_xDays`"
                  :name="`file_${i}_xDays`"
                  v-model="file.expirationInXDays"
                  v-validate="'required|numeric|min_value:1|max_value:9999'"
                  :state="!errors.has(`file-form.file_${i}_xDays`) &&
                  file.expirationInXDays > 0"
                  :change="setExpirationDate(file)"
                  type="number" min="1" max="9999"
                  data-cy="day"
                />
                <FormError
                  :attributeName="`file-form.file_${i}_xDays`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- EXPIRATION DATE -->
              <b-form-group
                v-if="file.selectedExpirationType !== expirationTypes.NO_EXPIRATION"
                :label="expirationLabel(file)"
                :label-for="`file_${i}_expirationDate`"
              >
                <b-form-datepicker
                  reset-button
                  label-reset-button="Limpiar"
                  :id="`file_${i}_expirationDate`"
                  :name="`file_${i}_expirationDate`"
                  data-vv-as="fecha de expiración"
                  placeholder="Selecciona una fecha"
                  v-model="file.expirationDate"
                  class="form-control bg-white"
                  v-validate="'required'"
                  locale="es"
                  :min="minDate"
                  label-help="Puede usar las flechas del teclado y espacio"
                  :state="!errors.has('file-form.expirationDate') &&
                    file.expirationDate !== null"
                  :disabled="file.selectedExpirationType
                    === expirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS"
                  data-cy="calendar"
                />
                <FormError
                  :attributeName="`file-form.file_${i}_expirationDate`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- EXPIRATION HOUR -->
              <b-form-group
                v-if="file.selectedExpirationType !== expirationTypes.NO_EXPIRATION"
                label="Hora de expiración"
                :label-for="`file_${i}_expirationHour`"
              >
                <b-form-select
                  :id="`file_${i}_expirationHour`"
                  :name="`file_${i}_expirationHour`"
                  :options="hours"
                  data-vv-as="hora de expiración"
                  placeholder="Selecciona una hora"
                  v-model="file.expirationHour"
                  class="w-100"
                  v-on:change="() => setExpirationNotification(file)"
                  v-validate="'required'"
                  :state="!errors.has(`file-form.file_${i}_expirationHour`) &&
                    file.expirationHour !== null"
                  data-cy="hour"
                />
                <b-form-invalid-feedback
                  class="d-none w-100"
                  :state="!errors.has(`file-form.file_${i}_expirationHour`)">
                  La hora es requerida
                </b-form-invalid-feedback>
                <FormError
                  :attributeName="`file_${i}_expirationHour`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- NOTIFICATION DATE -->
              <b-form-group
                v-show="file.selectedExpirationType !== expirationTypes.NO_EXPIRATION
                  && file.expirationDate && file.expirationHour"
                label="Fecha de notificación"
                :label-for="`file_${i}_notificationDate`"
              >
                <b-form-datepicker
                  reset-button
                  label-reset-button="Limpiar"
                  :id="`file_${i}_notificationDate`"
                  :name="`file_${i}_notificationDate`"
                  placeholder="Selecciona una fecha"
                  :value="file.notificationDate"
                  class="form-control bg-white"
                  locale="es"
                  :min="fileToUpload.date.substring(0,10)"
                  :max="file.expirationDate"
                  label-help="Puede usar las flechas del teclado y espacio"
                  data-cy="calendar"
                  @input="(val) => setNotificationDate(val, file.id)"
                />
                <FormError
                  :attributeName="`file-form.file_${i}_notificationDate`"
                  :errorsForm="errors"
                />
              </b-form-group>
              <!-- NOTIFICATION HOUR -->
              <b-form-group
                v-show="file.selectedExpirationType !== expirationTypes.NO_EXPIRATION
                  && file.expirationDate && file.expirationHour"
                label="Hora de notificación"
                :label-for="`file_${i}_notificationHour`"
              >
                <b-form-select
                  :id="`file_${i}_notificationHour`"
                  :name="`file_${i}_notificationHour`"
                  :options="hours"
                  data-vv-as="hora de notificación"
                  v-model="file.notificationHour"
                  class="w-100"
                  v-validate="{
                    between: true,
                    required: file.selectedExpirationType !== expirationTypes.NO_EXPIRATION,
                  }"
                  :state="!errors.has(`file-form.file_${i}_notificationHour`)&&
                    file.notificationHour !== null"
                  data-cy="hour"
                />
                <!-- TODO: Cambiar mensaje de error al por defecto.
                Por ahora no funciona, posible bug -->
                <b-form-invalid-feedback
                  class="d-none w-100"
                  :state="!errors.has(`file-form.file_${i}_notificationHour`)">
                  La fecha y hora debe ser antes de la expiración y posterior a la de creación
                </b-form-invalid-feedback>
                <FormError
                  :attributeName="`file_${i}_notificationHour`"
                  :errorsForm="errors"
                />
              </b-form-group>
            </div>
          </keep-alive>
        </div>
        <div class="m-top-20 d-flex justify-end">
          <b-button
            class="mt-5 ml-3 border-primary"
            type="submit"
            variant="outline-primary"
            :disabled="!Object.keys(filesStack).length"
            data-cy="save"
          >
            Guardar
            <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

import DocManagmentUploadFile from '@/febos/global/_vue/componentes/DocManagmentUploadFile';
import FormError from '@/febos/global/documentManagement/components/FormError';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import PublicationStateTypes from '@/febos/global/documentManagement/mixins/PublicationStateTypes';
import ValidityStateTypes from '@/febos/global/documentManagement/mixins/ValidityStateTypes';
import ExpirationTypes from '@/febos/global/documentManagement/mixins/ExpirationTypes';
import hours from '@/febos/global/documentManagement/mixins/HoursOptions';
import { SAVAL } from '@/constants/companies';

export default {
  name: 'NewFilesForm',
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      minDate: this.$moment().format('YYYY-MM-DD'),
      selectedFile: false,
      showErrorMessage: false,
      filesStack: {},
      loading: false,
      fileToUpload: {},
      selectedTab: 0,
      tabs: [],
      hours,
      approvalStateTypes: ApprovalStateTypes,
      publicationStateTypes: PublicationStateTypes,
      validityStateTypes: ValidityStateTypes,
      expirationTypes: ExpirationTypes,
      regexValidation: /.*/,
      expirationTypeOptions: [
        {
          value: ExpirationTypes.NO_EXPIRATION,
          text: 'Sin expiración'
        },
        {
          value: ExpirationTypes.ANNUAL_CYCLICAL_EXPIRATION,
          text: 'Expiración cíclica anual'
        },
        {
          value: ExpirationTypes.MONTHLY_CYCLICAL_EXPIRATION,
          text: 'Expiración cíclica mensual'
        },
        {
          value: ExpirationTypes.UNIQUE_EXPIRATION_DATE,
          text: 'Expiración única con fecha exacta'
        },
        {
          value: ExpirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS,
          text: 'Expiración única en (x) días'
        }
      ],
      publicationStateOptions: [
        {
          value: PublicationStateTypes.PUBLISHED,
          text: 'Publicado'
        },
        {
          value: PublicationStateTypes.DRAFT,
          text: 'Borrador'
        }
      ]
    };
  },
  components: {
    DocManagmentUploadFile,
    FormError
  },
  created() {
    this.validateNotificationTime();
  },
  methods: {
    ...mapActions('DocManagement', [
      'uploadFile'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    setNotificationDate(val, id) {
      this.filesStack[id].notificationDate = val;
    },
    validateNotificationTime() {
      // Crea validacion de libreria VeeValidate customizada
      const self = this;
      this.$validator.extend('between', {
        getMessage(field) {
          return `La ${field} debe ser anterior a la de expiración`;
        },
        validate() {
          /* Obtengo las keys del objeto filesStack y
          como es un array, tomo la posición respecto al tab elegido   */
          const fileIds = Object.keys(self.filesStack);
          const currentFieldId = fileIds[self.selectedTab];

          /* Parseo las fechas para obtener numeros y poder compararlos.
          Agrego la T para que el formato sea válido */
          const startDateTime = Date.parse(
              `${self.fileToUpload.date.split(' ')[0]}T${self.fileToUpload.date.split(' ')[1]}`
          );

          const { expirationDate } = self.filesStack[currentFieldId];
          const expirationTime = self.filesStack[currentFieldId].expirationHour;
          const endDateTime = Date.parse(`${expirationDate}T${expirationTime}:00:00`);

          const { notificationDate } = self.filesStack[currentFieldId];
          const notificationTime = self.filesStack[currentFieldId].notificationHour;
          const notificationDateTime = Date.parse(`${notificationDate}T${notificationTime}:00:00`);

          return notificationDateTime > startDateTime && notificationDateTime < endDateTime;
        }
      });
    },
    async save() {
      if (this.loading) {
        return;
      }
      const formCheck = await this.$validator.validateAll('file-form');
      if (formCheck) {
        this.showErrorMessage = false;
        this.loading = true;
        await this.uploadFiles();
        this.$bvToast.toast(
          'El/Los documento(s) ha(n) sido creado(s) correctamente!',
          {
            title: this.title,
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 15000
          }
        );
      } else {
        this.showErrorMessage = true;
      }
    },
    async addFile() {
      if (this.fileToUpload.failed) {
        // TODO: display error message.
        console.log('error', this.fileToUpload.failedMessage);
        return;
      }
      const newFile = {
        id: this.fileToUpload.id,
        originalFileName: this.fileToUpload.name,
        extension: this.fileToUpload.name.split('.').pop().toLowerCase(),
        name: this.fileToUpload.name.split('.').shift(),
        path: this.fileToUpload.path,
        externalVersion: '',
        isPublic: false,
        publicationState: PublicationStateTypes.PUBLISHED,
        selectedExpirationType: ExpirationTypes.NO_EXPIRATION,
        expirationDate: null,
        expirationHour: null,
        notificationDate: this.isSaval ? this.$moment().add(60, 'days').format('YYYY-MM-DD') : null,
        notificationHour: null,
        expirationInXDays: ''
      };
      this.filesStack = { ...this.filesStack, [newFile.id]: newFile };
      await this.$validator.reset();
      this.selectedFile = true;
    },
    removeFile(fileId) {
      const { [fileId]: ignored, ...copyFolders } = this.filesStack;
      this.filesStack = copyFolders;
      if (Object.keys(this.filesStack).length) {
        this.selectFile(0);
      } else {
        this.selectedFile = false;
      }
    },
    selectFile(index) {
      this.selectedTab = index;
      this.selectedFile = true;
    },
    async uploadFiles() {
      await Promise.all(Object.values(this.filesStack).map(async (file) => {
        await this.uploadFile({
          repositoryId: this.repositoryId,
          folderId: this.getSelectedFolderId,
          file: {
            carpetaId: this.getSelectedFolderId,
            nombre: `${file.name}.${file.extension}`,
            urlTransito: file.path,
            esPublico: this.isPublicLabel(file.isPublic),
            idioma: 'es',
            versionExterna: file.externalVersion,
            estadoVigencia: this.getValidityState(file),
            estadoAprobacion: this.approvalStateTypes.NOT_APPLY,
            estadoPublicacion: file.publicationState,
            tipoExpiracion: file.selectedExpirationType,
            fechaVencimiento: this.getExpirationDate(file),
            fechaNotificacion: this.getNotificationDate(file)
          }
        });
        await new Promise((resolve) => setTimeout(resolve, 10));
      }));
    },
    isPublicLabel(flag) {
      if (flag) {
        return 'S';
      }
      return 'N';
    },
    getValidityState(file) {
      if (file.selectedExpirationType === ExpirationTypes.NO_EXPIRATION) {
        return ValidityStateTypes.NOT_APPLY;
      }
      return ValidityStateTypes.VALID;
    },
    expirationLabel(file) {
      if (file.selectedExpirationType === ExpirationTypes.UNIQUE_EXPIRATION_DATE) {
        return 'Fecha de expiración';
      }
      return 'Primera fecha de expiración';
    },
    setExpirationDate(file) {
      if (file.selectedExpirationType === ExpirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS) {
        this.filesStack[file.id].expirationDate = this.$moment()
          .add(file.expirationInXDays, 'd').format('YYYY-MM-DD');
      }
    },
    getExpirationDate(file) {
      let date = null;
      if (file.expirationDate && file.expirationHour) {
        date = `${file.expirationDate} ${file.expirationHour}:00:00`;
      } else if (file.selectedExpirationType === ExpirationTypes.NO_EXPIRATION) {
        return date;
      }
      return date;
    },
    getNotificationDate(file) {
      let notificationDate = null;
      if (file.notificationDate && file.notificationHour) {
        notificationDate = `${file.notificationDate} ${file.notificationHour}:00:00`;
      } else if (file.selectedExpirationType === ExpirationTypes.NO_EXPIRATION) {
        return notificationDate;
      }
      return notificationDate;
    },
    setExpirationNotification(file) {
      if (this.isSaval
        && (
          this.filesStack[file.id].notificationDate === null
          || !this.filesStack[file.id].notificationDate
        )
      ) {
        this.filesStack[file.id].notificationDate = Vue.moment().add(60, 'days').format('YYYY-MM-DD');
      }
    }
  },
  watch: {
    filesStack: {
      handler(val) {
        /* Permite dejar nulos los campos descritos del archivo elegido
        al quedar sin expiración el archivo. Esto es útil cuando se le intento
        asignar expiración pero después se cambio de idea */
        const fileIds = Object.keys(this.filesStack);
        const currentFieldId = fileIds[this.selectedTab];
        if (
          val[currentFieldId].selectedExpirationType === ExpirationTypes.NO_EXPIRATION
        ) {
          this.$validator.reset(); // Resetear validador para evitar errores
          this.filesStack[currentFieldId].expirationDate = null;
          this.filesStack[currentFieldId].expirationHour = null;
          this.filesStack[currentFieldId].notificationDate = this.isSaval
            ? Vue.moment().add(60, 'days').format('YYYY-MM-DD')
            : null;
          this.filesStack[currentFieldId].notificationHour = null;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getRepositories'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    isSaval() {
      return this.company.iut === SAVAL.iut;
    },
    showModal: {
      get() {
        return this.modalName === 'fileFormED';
      },
      set() {
        this.closeModal();
      }
    },
    title() {
      let response = '';
      const prep = this.isEdit ? 'Editar' : 'Agregar documento a';
      if (this.getSelectedFolderId) {
        response = `${prep} ${this.getTreeElements[this.getSelectedFolderId].nombre}`;
      }
      if (this.getSelectedRepositoryId) {
        response = `${prep} ${this.getRepositories[this.getSelectedRepositoryId].nombreRepositorio}`;
      }
      if (this.getSelectedElement && this.isEdit) {
        response = `${prep} ${this.getSelectedElement.name}`;
      }
      return response;
    },
    repositoryId() {
      let response = '';
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].repositoryId;
      }
      if (this.getSelectedRepositoryId) {
        response = this.getSelectedRepositoryId;
      }
      return response;
    },
    filesErrors() {
      const response = {};
      Object.keys(this.filesStack).forEach((file, i) => {
        response[i] = 0;
        this.errors.items.forEach((item) => {
          if (item.field.includes(`file_${i}_`)) {
            response[i] += 1;
          }
        });
      });
      return response;
    },
  }
};
</script>

<style lang="scss" scoped>
.tab-selected {
  border-bottom-width: 2px;
  border-bottom-color: purple;
  border-bottom-style: solid;
}
.invalid-feedback {
  font-size: 12px;
  color: #AD8ABD;
}

</style>
